
import Vue from 'vue'
import App from './App'
import router from './router'
import { Get, Post,Put,Delete, Get2, Post2} from './assets/common/js/https';
import  './assets/svgs/index';
import store from './store/index'
import './assets/common/font/iconfont.css'
import './assets/common/css/common.scss'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant/es'
import 'vant/lib/index.css'

import Header from './components/Header.vue'
import Footer from './components/Footer.vue'
import nodata from './components/nodata.vue'
import crumbs from "@/components/crumbs";
import login from '@/components/login/login.vue';



Vue.prototype.$get = Get;
Vue.prototype.$post = Post;
Vue.prototype.$put = Put;
Vue.prototype.$delete = Delete;
Vue.prototype.$get2 = Get2;
Vue.prototype.$post2 = Post2;
Vue.config.productionTip = false


router.beforeEach((to, from, next) =>{
  // if(to.query.code){
  //   if(!store.state.loginInfo.Token){
  //     // router.app.$store.commit('qrCodeLogin',to.query.code)
  //     router.app.$options.store.commit('qrCodeLogin',to.query.code)
  //   }
  // }
  if (to.meta.title) {
      document.title = '英才苑府-'+to.meta.title;
    } 
    window.scrollTo(0, 0);
    next();
});
Vue.component('Header', Header)
Vue.component('Footer', Footer)
Vue.component('nodata', nodata)
Vue.component('crumbs', crumbs)
Vue.component('login', login)

Vue.use(Vant)
Vue.use(ElementUI);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js